import { useAuth0 } from '@auth0/auth0-react';
import { Alert, Button, Stack, Text, Title } from '@mantine/core';
import { IconAlertTriangle, IconLogout } from '@tabler/icons-react';
import OnboardingShell from './OnboardingShell';

export default function AuthenticationSetupErrorPage() {
  const { logout } = useAuth0();

  const handleSignOut = () => {
    logout({ logoutParams: { returnTo: window.location.origin } });
  };

  return (
    <OnboardingShell
      stageLabel="Account verification"
      reassurance="Your account has not been created in The Game Project."
    >
      <Stack gap="lg">
        <Title order={1}>Email verification was not completed</Title>
        <Alert icon={<IconAlertTriangle size={18} />} color="orange" title="Unable to finish account setup">
          Auth0 returned your account without a verified email address. Sign out and start signup again to enter the
          verification code, or contact support if the problem continues.
        </Alert>
        <Text c="dimmed">
          For your security, we cannot create or update an account until Auth0 confirms that you control the email
          address.
        </Text>
        <Button leftSection={<IconLogout size={18} />} onClick={handleSignOut}>
          Sign out and try again
        </Button>
      </Stack>
    </OnboardingShell>
  );
}
